export interface InvokableAction {
  /** Optional disambiguating id for when want multiple instances with same name and type */
  id?: string;
  nodeId: number;
  name: string;
  type: string;
  payload?: Record<string, unknown>;
  /** Property paths within payload that are node references */
  payloadNodeRefProps?: string[];
}

export type InvokableActionIdentifier = Pick<InvokableAction, "nodeId" | "name" | "id">;

export type InvokableActionIdString =
  | `${InvokableActionIdentifier["nodeId"]}:${InvokableActionIdentifier["name"]}:${InvokableActionIdentifier["id"]}`
  | "";

export const nodeActionIdToIdString = (arg: InvokableActionIdentifier | undefined): InvokableActionIdString =>
  arg ? `${arg.nodeId}:${arg.name}:${arg.id ?? ""}` : "";

export const nodeActionIdStringToActionId = (value: InvokableActionIdString): InvokableActionIdentifier => {
  const [nodeId, name, id] = value.split(":");
  return { nodeId: Number(nodeId), name, id: id || undefined };
};
